import { ISubscriptionStatusProps, TSubscriptionID } from '../types';
import ActiveStatus from './statuses/ActiveStatus';
import CancelledStatus from './statuses/CancelledStatus';
import FutureStatus from './statuses/FutureStatus';
import InTrialStatus from './statuses/InTrialStatus';
import NonRenewingStatus from './statuses/NonRenewingStatus';
import PausedStatus from './statuses/PausedStatus';

interface IChargebeeSubscriptionStatusProps extends ISubscriptionStatusProps {
  onTerminateSubscription: (id: TSubscriptionID) => void;
}

export default function ChargebeeSubscriptionStatus({
  subscription,
  onTerminateSubscription,
}: Readonly<IChargebeeSubscriptionStatusProps>) {
  switch (subscription.status) {
    case 'active':
      return <ActiveStatus subscription={subscription} onTerminateSubscription={onTerminateSubscription} />;
    case 'in_trial':
      return <InTrialStatus subscription={subscription} onTerminateSubscription={onTerminateSubscription} />;
    case 'cancelled':
      return <CancelledStatus subscription={subscription} />;
    case 'future':
      return <FutureStatus subscription={subscription} />;
    case 'non_renewing':
      return <NonRenewingStatus subscription={subscription} />;
    case 'paused':
      return <PausedStatus subscription={subscription} />;
    default:
      return null;
  }
}
